// Ends an expired customer session after a 401. Auth journeys handle their own 401s (wrong password, bad OTP...).
const AUTH_ENDPOINTS = ['/login', '/register', '/forget-password', '/verify-otp', '/reset-password', '/set-password'];

function endpointPath(url) {
  try {
    return new URL(String(url || ''), 'http://leader.local/').pathname.replace(/\/+$/, '');
  } catch {
    return '';
  }
}

function sentToken(config) {
  const headers = config?.headers;
  if (!headers) return '';
  const value = typeof headers.get === 'function' ? headers.get('Authorization') : headers.Authorization;
  return typeof value === 'string' ? value : '';
}

export function isExpiredSession(error, currentToken) {
  if (error?.response?.status !== 401 || !currentToken) return false;
  const path = endpointPath(error.config?.url);
  if (AUTH_ENDPOINTS.some(p => path === p || path.endsWith('/api' + p))) return false;
  // A stale request from an earlier session must not end the current one.
  return sentToken(error.config) === 'Bearer ' + currentToken;
}

export function installSessionGuard(axios, store, onExpired = () => window.location.replace('/login?session=expired')) {
  let expiring = false;
  return axios.interceptors.response.use(
    response => response,
    error => {
      if (!isExpiredSession(error, store.getters.token)) return Promise.reject(error);
      if (!expiring) {
        expiring = true;
        store.dispatch('logout', { localOnly: true });
        onExpired();
      }
      // Keep callers pending while the page is replaced, so they don't flash an error first.
      return new Promise(() => {});
    }
  );
}
